import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class ProductValidation extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		const properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;

		const validator = new Validator();
		this.message = '';
		if (properties.find(p => p == 'accomodation') != null) {
			const accommodation: any = dynamicProperties['accomodation'];
			if (!validator.isNotEmpty(accommodation.checkIn)) {
				this.message = 'CheckIn is required <br />';
				result = false;
			}
			if (!validator.isNotEmpty(accommodation.checkOut)) {
				this.message = this.message.concat('CheckOut is required <br />');
				result = false;
			}
		} else if (properties.find(p => p == 'flight') != null) {
			const flight: any = dynamicProperties['flight'];
			if (!validator.isNotEmpty(flight.originAirportId)) {
				this.message = 'Origin Airport is required <br />';
				result = false;
			}
			if (!validator.isNotEmpty(flight.destinationAirportId)) {
				this.message = this.message.concat('Destination Airport is required <br />');
				result = false;
			}
			if (!validator.isNotEmpty(flight.airlineId)) {
				this.message = this.message.concat('Airline is required <br />');
				result = false;
			}
		} else if (properties.find(p => p == 'transfer') != null) {
			const transfer: any = dynamicProperties['transfer'];
			if (!validator.isNotEmpty(transfer.originPlaceId)) {
				this.message = 'Origin Place is required <br />';
				result = false;
			}
			if (!validator.isNotEmpty(transfer.destinationPlaceId)) {
				this.message = this.message.concat('Destination Place is required <br />');
				result = false;
			}
			if (!validator.isNotEmpty(transfer.duration)) {
				this.message = this.message.concat('Duration time is required <br />');
				result = false;
			}
		}

		return result;
	}

	defaultMessage(args: ValidationArguments) {
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/productValidator.ts